export const endpoints = {
  searchExternalUrls: 'externalUrl/search',
  deleteExternalUrlItem: 'externalUrl'
};
